import { Grid } from '@material-ui/core';
import { FormikTextField, FormikDatePicker } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputAdornment from '@material-ui/core/InputAdornment';
import { getMinimalOrderDate, shouldDisableOrderPickupDate } from '@dnb/common';

const BaseOrderForm = () => {
  const { t } = useTranslation();

  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <FormikTextField
          type="number"
          variant="outlined"
          margin="normal"
          required
          fullWidth
          label={t('labels:amount')}
          id="amount"
          name="amount"
          inputProps={{
            step: 1,
            min: 0,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span>kg</span>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormikDatePicker
          margin="normal"
          required
          fullWidth
          label={t('labels:pickupDate')}
          id="pickupDate"
          name="pickupDate"
          format="dd/MM/yyyy"
          inputVariant="outlined"
          minDate={getMinimalOrderDate()}
          shouldDisableDate={shouldDisableOrderPickupDate}
        />
      </Grid>
      <Grid item xs={12}>
        <FormikTextField
          type="text"
          variant="outlined"
          margin="normal"
          fullWidth
          label={t('labels:comments')}
          id="comments"
          name="comments"
          multiline
          rows={3}
        />
      </Grid>
    </Grid>
  );
};

export default BaseOrderForm;
